module.exports = __webpack_public_path__ + "static/media/background.20ce67fc.png";